import { Injectable } from '@angular/core';
import { FormGroup, AbstractControl, ValidatorFn } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class ValidatorsService {
  plzValidator(laendercodeControl: string): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (!control.parent) {
        return null;
      }

      const plz         = control.value;
      const laendercode = control.parent.get(laendercodeControl)?.value;

      if (laendercode) {
        let regex;
        switch (laendercode) {
          case 'DE':
            regex = /^[0-9]{5}$/;
            break;
          case 'GB':
            regex = /GIR[ ]?0AA|((AB|AL|B|BA|BB|BD|BH|BL|BN|BR|BS|BT|CA|CB|CF|CH|CM|CO|CR|CT|CV|CW|DA|DD|DE|DG|DH|DL|DN|DT|DY|E|EC|EH|EN|EX|FK|FY|G|GL|GU|HA|HD|HG|HP|HR|HS|HU|HX|IG|IP|IV|KA|KT|KW|KY|L|LA|LD|LE|LL|LN|LS|LU|M|ME|MK|ML|N|NE|NG|NN|NP|NR|NW|OL|OX|PA|PE|PH|PL|PO|PR|RG|RH|RM|S|SA|SE|SG|SK|SL|SM|SN|SO|SP|SR|SS|ST|SW|SY|TA|TD|TF|TN|TQ|TR|TS|TW|UB|W|WA|WC|WD|WF|WN|WR|WS|WV|YO|ZE)(\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2}))$/;
            break;
          case 'FR':
            regex = /^[0-9]{2} ?[0-9]{3}$/;
            break;
          case 'PL':
            regex = /^[0-9]{2}-[0-9]{3}$/;
            break;
          case 'CH':
            regex = /^[0-9]{4}$/;
            break;
          case 'LU':
            regex = /^[0-9]{4}$/;
            break;
          case 'BE':
            regex = /^[0-9]{4}$/;
            break;
          case 'AT':
            regex = /^[0-9]{4}$/;
            break;
          case 'ES':
            regex = /^[0-9]{5}$/;
            break;
          default:
            return null;
        }
        return regex.test(plz) ? null : {'invalidPLZ': true};
      }
      else {
        return null;
      }
    };
  }
}